$( document ).ready(function() {
  
  /**	slicks Influencers*/
  
  if($(".influencers-slide").length){
    $('.influencers-slide').slick({
      slidesToShow: 3.5,
      slidesToScroll: 1,
      nextArrow: '<button type="button" aria-label="Next Product" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
      prevArrow: '<button type="button" aria-label="Previous Product" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }

  if($('.videoStorieResponsive video').length){
    if (window.innerWidth > 1025) {
      $('.videoStorieResponsive video').hover(function toggleControls() {
        if (this.hasAttribute("controls")) {
          this.removeAttribute("controls")
        } else {
          this.setAttribute("controls", "controls")
        }
      })
    }else{  
      $('.videoStorieResponsive video').each(function( index ) {
        this.setAttribute("controls", "controls")
      });
    }

    $('.videoStorieResponsive video').each(function( index ) {
      this.load();
    });

    if (window.innerWidth > 1025) {
      $('body').on("click touchstart", ".videoStorieResponsive video", function(event, salutation, video){
        event.preventDefault();
        $('.videoStorieResponsive video').each(function() {
          if(event.currentTarget != this){
            this.pause();
          }else{
            this.paused ? this.play() : this.pause();
          };
        });

      });
    }

    $('.influencers-slide').on('beforeChange', function(event, slick, currentSlide, nextSlide){

      if (window.innerWidth < 1025) {
        if($(slick.$slides[currentSlide]).children("video").length){
          $(slick.$slides[currentSlide]).children(".videoStorieResponsive").children("video").get(0).pause();
        }
        if($(slick.$slides[nextSlide]).children("video").length){
          $(slick.$slides[nextSlide]).children(".videoStorieResponsive").children("video").get(0).play();
        }
      }else{
        $('.videoStorieResponsive video').each(function( index ) {
          this.pause();
        });
      }
    });
  }
  
//   var categoriasHome;

  if($(".slider-brands-products").length){
    var sliderNews = new Swiper(".slider-brands-products", {
      slidesPerView: 1.5,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 2.5
        },
        1024: {
          slidesPerView: 4.5
        },
      }
    });
  }


  if($('.compre-o-look').length){
    $('.compre-o-look').slick({
      infinite: false,
      slidesToShow: 1.3,
      slidesToScroll: 1,
      swipeToSlide: true,
      prevArrow: '<button type="button" aria-label="Previous Product" class="slick-prev slick-arrow" aria-disabled="false" style="display: block;"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>',
      nextArrow: '<button type="button" aria-label="Next Product" class="slick-next slick-arrow" style="display: block;" aria-disabled="false"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>',
      responsive: [
        {
          breakpoint: 570,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }  
  
  if($(".influencers-home").length){
    var influencersHome = new Swiper(".influencers-home", {
      slidesPerView: 2,
      spaceBetween: 10,
      breakpoints: {
        640: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 5.5
        },
      }
    });
  }

  if($(".slide-split").length){
    var slideSplit = new Swiper(".slide-split", {
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        640: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 1
        },
        1024: {
          slidesPerView: 2
        },
      }
    });
  }

  function resetSlider(){
    if ($(window).width() < 1024) {
      //categoriasHome.destroy( true, true )
    }else{
//       categoriasHome = new Swiper(".categories-home", {
//         slidesPerView: 2.5,
//         spaceBetween: 10,
//         updateOnWindowResize: true,
//         pagination: {
//           el: ".swiper-pagination",
//           clickable: true,
//         },
//         breakpoints: {
//           640: {
//             slidesPerView: 3.5
//           },
//           768: {
//             slidesPerView: 3.5
//           },
//           1024: {
//             slidesPerView: 9
//           },
//         }
//       }); 
    }
  }
  
  resetSlider();
  
  $(window).on('resize', function () {
    resetSlider();
  });

//   if($(".marcas-menu-slide").length){
//     var marcasMenu = new Swiper(".marcas-menu-slide", {
//       slidesPerView: 7.5,
//       spaceBetween: 10
//     });
//   }
 
//   $(document).on('mouseover', '.mega-menu', function(event) {
//     if($(".marcas-menu-slide").length){
//       var marcasMenu = new Swiper(".marcas-menu-slide", {
//         slidesPerView: 7.5,
//         spaceBetween: 10
//       });
//     }
//   });
  
  /* Frete lateral */
  function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");

    $(element).text('copiado');
    setTimeout( function() { $(element).text($temp.val()); $temp.remove(); }, 3000);

  }

  /*Frete Lateral*/

  function limpa_formulário_cep() {
    /*Limpa valores do formulário de cep.*/
    $("#cep-frete").val("");
    $("#pais-frete").val("");
    $("#estado-frete").val("");
  };

  function buscarCEP(inputCEP){

    /*Nova variável "cep" somente com dígitos.*/
    var cep = inputCEP.val().replace(/\D/g, '');
    var cepLimpo = inputCEP.val().replace(/\D/g, '');

    /*Verifica se campo cep possui valor informado.*/
    if (cep != "") {

      /*Expressão regular para validar o CEP.*/
      var validacep = /^[0-9]{8}$/;

      /*Valida o formato do CEP.*/
      if(validacep.test(cep)) {

        /*Consulta o webservice viacep.com.br*/
        $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
          if (!("erro" in dados)) {

            switch(dados.uf){
              case 'AC': dados.uf = 'Acre'; break;
              case 'AL': dados.uf = 'Alagoas'; break;
              case 'AP': dados.uf = 'Amapa'; break;
              case 'AM': dados.uf = 'Amazonas'; break;
              case 'BA': dados.uf = 'Bahia'; break;
              case 'CE': dados.uf = 'Ceara'; break;
              case 'DF': dados.uf = 'Distrito Federal'; break;
              case 'ES': dados.uf = 'Espirito Santo'; break;
              case 'GO': dados.uf = 'Goias'; break;
              case 'MA': dados.uf = 'Maranhao'; break;
              case 'MT': dados.uf = 'Mato Grosso'; break;
              case 'MS': dados.uf = 'Mato Grosso do Sul'; break;
              case 'MG': dados.uf = 'Minas Gerais'; break;
              case 'PA': dados.uf = 'Para'; break;
              case 'PB': dados.uf = 'Paraiba'; break;
              case 'PR': dados.uf = 'Parana'; break;
              case 'PE': dados.uf = 'Pernambuco'; break;
              case 'PI': dados.uf = 'Piaui'; break;
              case 'RJ': dados.uf = 'Rio de Janeiro'; break;
              case 'RN': dados.uf = 'Rio Grande do Norte'; break;
              case 'RS': dados.uf = 'Rio Grande do Sul'; break;
              case 'RO': dados.uf = 'Rondonia'; break;
              case 'RR': dados.uf = 'Roraima'; break;
              case 'SC': dados.uf = 'Santa Catarina'; break;
              case 'SP': dados.uf = 'Sao Paulo'; break;
              case 'SE': dados.uf = 'Sergipe'; break;
              case 'TO': dados.uf = 'Tocantins'; break;
            }; 

            console.log(dados.uf);

            //Atualiza os campos com os valores da consulta.
            $("#cep-frete").val(dados.cep);
            $("#pais-frete").val("Brazil");
            $("#estado-frete").val(dados.uf);

            var cep = cep,
                pais = $("#pais-frete").val(),
                estado = $("#estado-frete").val();

            console.log(cepLimpo);

            $.ajax({
              type: "GET", //rest Type
              dataType: "json", //mispelled
              url: "/cart/shipping_rates.json?shipping_address%5Bzip%5D="+cepLimpo+"&shipping_address%5Bcountry%5D="+pais+"&shipping_address%5Bprovince%5D="+estado,
              beforeSend: function() {
                $('.overlay-carregando').show();
              },
              success: function (msg) {

                if (msg.shipping_rates[0].price == "0.00"){
                  $(".preco-frete").html("Grátis");
                }else{
                  $(".preco-frete").html("R$ "+msg.shipping_rates[0].price);
                }

                $("#fretes-disponiveis").empty();

                for(i = 0; i < msg.shipping_rates.length; i++) {
                  if (msg.shipping_rates[i].price == "0.00"){
                    $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name+" - grátis", [i]));
                  }else{
                    if (msg.shipping_rates[i].delivery_days[1] == "0"){
                      $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name+" - R$ "+msg.shipping_rates[i].price, [i]));
                    }else{
                      $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name+" - R$ "+msg.shipping_rates[i].price+" ("+msg.shipping_rates[i].delivery_days[1]+" dias úteis)", [i]));
                    }
                  };

                  $("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
                }             
                $(".resultado-frete-lateral").show();


                $('.overlay-carregando').hide();

                jQuery.getJSON('/cart.js', function(cart) {
                  var subtotal = cart.total_price;
                  var frete = parseInt($('#fretes-disponiveis').find(":selected").data("valor").replace(".", ""));
                  var total = subtotal + frete;

                  $('.label-total-preco').html(
                    Shopify.formatMoney(total, window.money_format)
                  );   

                });
                $('.total-carrinho').show();

                setTimeout(function() {$('#fretes-disponiveis').click(); console.log("Teste")}, 2000);

              },
              error: function(erro) {
                $(".resultado-frete-lateral").hide();
                $(".preco-frete").html("--");
                limpa_formulário_cep();
                $('.overlay-carregando').hide();
                $('.total-carrinho').hide();
              }
            });
          } //end if.
          else {
            //CEP pesquisado não foi encontrado.
            limpa_formulário_cep();
            $(".resultado-frete-lateral").hide();
            $(".overlay-carregando").hide();
            alert("CEP não encontrado.");
            $('.total-carrinho').hide();
          }
        });
      } //end if.
      else {
        //cep é inválido.
        limpa_formulário_cep();
        $(".resultado-frete-lateral").hide();
        alert("Formato de CEP inválido.");
        $('.overlay-carregando').hide();
        $('.total-carrinho').hide();
      }
    } /*end if.*/
    else {
      //cep sem valor, limpa formulário.
      limpa_formulário_cep();
    }
  };

  $("#cep-frete").blur(function(){
    /*$('.overlay-carregando').show();*/
    buscarCEP($(this));
  });

  $("#cep-frete").on('keyup', function () {
    var numeros = $(this).val().replace(/\D/g, '').length;

    if(numeros == 8){
      $('.overlay-carregando').show();
      setTimeout(function(){$("#cep-frete").blur();}, 500);
    }
  });

  $("#cep-frete").on('keyup', function (event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if(keycode == '13'){
      $('.overlay-carregando').show();
      buscarCEP($(this)); 
    }
  });

  $("#fretes-disponiveis").change(function() {
    console.log($(this).find(':selected').data('valor'));
    var precoItem = $(this).find(':selected').data('valor');

    if(precoItem != 0.00){
      $(".preco-frete").html("R$ "+precoItem);
    }else{
      $(".preco-frete").html('GRÁTIS');
    }

    jQuery.getJSON('/cart.js', function(cart) {
      var subtotal = cart.total_price;
      var frete = parseInt($('#fretes-disponiveis').find(":selected").attr('data-valor').replace(".", ""));
      var total = subtotal + frete;

      $('.label-total-preco').html(
        Shopify.formatMoney(total, window.money_format)
      );  

    });

    $('.total-carrinho').show();

  });

  var freteExpress = {
    init: function(){
      this.initFrete();
    },
    initFrete: function(){
      $('.result-frete').click(function(){
        $(this).parent().addClass('cep-active');
      });

      $('form.cep-express').submit(function(e) {
        e.preventDefault();
        var cep = $('.input-cep').val().replace(/\D/g, '');

        freteExpress.encontrarDados(cep)
      });
    },
    encontrarDados: function(cep){    
      $.ajax({
        type: "GET",
        url: "https://viacep.com.br/ws/"+ cep +"/json/",
        beforeSend: function () {
          //Aqui adicionas o loader
          freteExpress.resetAll();
        },
        success: function(dados){
          console.log(dados);
          if (!("erro" in dados)) {
            switch(dados.uf){
              case 'AC': dados.uf = 'Acre'; break;
              case 'AL': dados.uf = 'Alagoas'; break;
              case 'AP': dados.uf = 'Amapa'; break;
              case 'AM': dados.uf = 'Amazonas'; break;
              case 'BA': dados.uf = 'Bahia'; break;
              case 'CE': dados.uf = 'Ceara'; break;
              case 'DF': dados.uf = 'Distrito Federal'; break;
              case 'ES': dados.uf = 'Espirito Santo'; break;
              case 'GO': dados.uf = 'Goias'; break;
              case 'MA': dados.uf = 'Maranhao'; break;
              case 'MT': dados.uf = 'Mato Grosso'; break;
              case 'MS': dados.uf = 'Mato Grosso do Sul'; break;
              case 'MG': dados.uf = 'Minas Gerais'; break;
              case 'PA': dados.uf = 'Para'; break;
              case 'PB': dados.uf = 'Paraiba'; break;
              case 'PR': dados.uf = 'Parana'; break;
              case 'PE': dados.uf = 'Pernambuco'; break;
              case 'PI': dados.uf = 'Piaui'; break;
              case 'RJ': dados.uf = 'Rio de Janeiro'; break;
              case 'RN': dados.uf = 'Rio Grande do Norte'; break;
              case 'RS': dados.uf = 'Rio Grande do Sul'; break;
              case 'RO': dados.uf = 'Rondonia'; break;
              case 'RR': dados.uf = 'Roraima'; break;
              case 'SC': dados.uf = 'Santa Catarina'; break;
              case 'SP': dados.uf = 'Sao Paulo'; break;
              case 'SE': dados.uf = 'Sergipe'; break;
              case 'TO': dados.uf = 'Tocantins'; break;
            }; 

            freteExpress.estimativaFrete({cep:cep,estado:dados.uf,pais:'Brazil'});
          }else{
            $('.erros-validacao').append( "<span class='erro-cep'>Corrija seu CEP</span>" ).show();
            freteExpress.changeOpacity('1');
            $(".result-frete").html("CLIQUE PARA CALCULAR");
            $('#fretes-disponiveis').hide();
          }
        },
        error: function(erro){
          freteExpress.erroOnCep('Erro, tente novamente.');
        },
        dataType: 'json'
      });
    },
    estimativaFrete: function(busca){

      function isDateBeforeToday(date) {
        return new Date(date.toDateString()) < new Date(new Date().toDateString());
      }

      $.ajax({
        type: "GET",
        url: '/cart/shipping_rates.json',
        data: {
          'shipping_address[country]':busca.pais,
          'shipping_address[province]':busca.estado,
          'shipping_address[zip]':busca.cep
        },
        beforeSend: function () {
          //Aqui adicionas o loader
          freteExpress.resetAll();
        },
        success: function(d){

          if (d.shipping_rates[0].price == "0.00"){
            $(".result-frete").html("Grátis");
          }else{
            $(".result-frete").html("R$ "+d.shipping_rates[0].price);
          }

          if(d.shipping_rates && d.shipping_rates.length){
            for (var i = 0; i < d.shipping_rates.length; i++) {
              if (d.shipping_rates[i].price == "0.00"){
                $("#fretes-disponiveis").append(new Option(d.shipping_rates[i].name, [i]));
              }else{
                if (d.shipping_rates[i].delivery_days[1] == "0" || d.shipping_rates[i].delivery_days[1] == "undefined"){
                  $("#fretes-disponiveis").append(new Option(d.shipping_rates[i].name+" - R$ "+d.shipping_rates[i].price, [i]));
                }else{
                  $("#fretes-disponiveis").append(new Option(d.shipping_rates[i].name+" - R$ "+d.shipping_rates[i].price+" ("+d.shipping_rates[i].delivery_days[1]+" dias úteis)", [i]));
                }
              };

              $("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", d.shipping_rates[i].price);
            };

            freteExpress.changeOpacity('1');
            $('.erro-cep').remove();
            $('.cep-inline').removeClass('cep-active');
            $('#fretes-disponiveis').show();
          }

          freteExpress.changeTotal();
        },
        error: function(){
          freteExpress.erroOnCep('Corrija seu CEP');
        },
        dataType: 'json'
      });
    },
    resetAll: function(){
      $('.erros-validacao').empty().hide();
      $('#fretes-disponiveis').empty();
      $('#fretes-disponiveis').hide();
      freteExpress.changeOpacity('0.5');
      $(".result-frete").html("CLIQUE PARA CALCULAR");
    },
    erroOnCep: function(erro){
      $('.erros-validacao').show().append( "<span class='erro-cep'>"+erro+"</span>" );
      freteExpress.changeOpacity('1');
      $(".result-frete").html("CLIQUE PARA CALCULAR");
      $('#fretes-disponiveis').hide();
    },
    changeTotal: function(){
      jQuery.getJSON('/cart.js', function(cart) {
        var subtotal = cart.total_price;
        var frete = parseInt($('#fretes-disponiveis').find(":selected").data("valor").toString().replace(".", ""));
        var total = subtotal + frete;

        console.log("frete: "+frete);

        $('.total > .price').html(
          Shopify.formatMoney(total, window.money_format)
        );   

      });
    },
    changeFreteLabel: function(){
      var frete = parseInt($('#fretes-disponiveis').find(":selected").data("valor").toString().replace(".", ""));
      $(".result-frete").html(
        Shopify.formatMoney(frete, window.money_format)
      );
    },
    changeOpacity: function(opacity){
      $('.input-cep').css('opacity', opacity);
    }
  }

  $(document).on("click", ".down-content", function() {
    var a = $(this).data("anchor"),
        r = $(a).offset().top - 63;
    $("html,body").animate({
      scrollTop: r
    }, "slow")
  })
  freteExpress.init();
  
});